<template>
  <div class="boss-web-top-list">
    <div v-if="this.$store.state.app.globalLoading" class="boss-web-loading">
      <img src="../assets/page-loading.gif" alt="" />
    </div>
    <el-menu v-if="isHidden" :default-active="active" @select="handleSelect" class="el-menu-box el-menu-main"
      mode="vertical" background-color="#fff" text-color="#000000" active-text-color="#ffd04b">
      <el-menu-item class="main-menu" index="0" :class="currentIndex == 0 ? 'active-disable' : ''"><img
          src="../assets/login.png" @click="clickItem(home)" /></el-menu-item>
      <el-scrollbar vertical="true" style="margin-right: 16px; flex: auto">
        <section class="nav">
          <el-menu-item v-for="(item, index) in menuData" :key="item.path || index" :index="item.path || index"
            @click="clickItem(item)">{{ item.name }}</el-menu-item>
        </section>
      </el-scrollbar>

      <section class="flex" style="flex: none">
        <el-menu-item class="login-info">欢迎：{{ loginInfoData.name }}</el-menu-item>
        <el-menu-item class="log-out" key="logOut" index="logOut" @click="logOut">退出</el-menu-item>
      </section>
    </el-menu>
    <el-menu v-if="!isHidden" class="el-menu-box el-menu-not el-menu-main island" mode="vertical">
      <el-menu-item index="0"> <img :src="isLang" class="is-lang" /> </el-menu-item></el-menu>
  </div>
</template>

<script>
import actions from "@/store/action";
import { getLogOut, getLoginInnerInfo, getLoginWebsites, getRefreshTime } from '../api/axios'
import { isHiddenList } from "./config";
import isLang from "../assets/islang.png";
export default {
  name: "main",
  data() {
    return {
      active: "",
      isLang,
      isHidden: true,
      currentIndex: -1,
      menuData: [
        {
          path: "/child-permission/home",
          name: "首页",
        },
      ],
      home: {
        path: "/child-permission/home",
      },
      getLoginTim: "",
      loginInfoData: {},
      base: process.env.VUE_APP_BASE_API || "",
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      this.currentIndex = key;
      if (key == 0) {
        this.active = "/child-permission/home";
      } else {
        this.active = key;
      }
    },
    logOut() {
      const accountId = JSON.parse(localStorage.getItem('loginInfo')).accountId

      let data = {
        accountId: accountId,
        loginDeviceType: "1",
        token: localStorage.getItem("token"),
      };
      
      getLogOut(data).then((res) => {
        localStorage.clear();
        location.href = window.location.origin + this.base + "/login";
      });
    },
    clickItem(item) {
      if (!item) {
        return false;
      }
      let path = this.base + item.path;
      localStorage.setItem("topMeunData", JSON.stringify(item));
      actions.setGlobalState({
        navInfo: item,
      });
      history.pushState(null, path, path);
    },

    getLoginInfo() {
      getLoginInnerInfo()
        .then(res => {
          this.loginInfoData = res?.data || {}
        })
        .catch(err => {
          console.log(err)
        })
    },

    setActive() {
      const pathNames = window.location.pathname.split("/");
      let activeRoute = "";
      let target;

      // 多层路由
      for (let i = 1; i < pathNames.length; i++) {
        activeRoute += `/${pathNames[i]}`;
        const targetList = this.menuData.filter((nav) => nav.path.includes(activeRoute));

        // 精准匹配上
        if (targetList.length === 1) {
          target = targetList[0];
          break;
        }

        if (targetList.length > 1 && i < pathNames.length - 1) continue;
        target = targetList.find((item) => item.path === activeRoute);
      }

      // FIXME: 没有权限但是通过url等方式进来的
      if (!target) return;

      this.$nextTick(() => {
        sessionStorage["boss_inner_nav_info"] = JSON.stringify(target);
        this.active = target.path;
      });
    },

    setNav(nav) {
      actions.setGlobalState({
        navInfo: nav,
      });
      localStorage.setItem("topMeunData" + nav, JSON.stringify(nav));
    },

    //获取登录网址列表
    getWebList() {
      getLoginWebsites().then((res) => {
        if (res.code == 200) {
          const noShowCodes = ['1', '4', '114', '3', '113', '116', '121', '136', '140']
          let arr = JSON.parse(JSON.stringify(this.menuData));
          res.data.forEach((item, index) => {
            if (noShowCodes.includes(item.id)) {
              arr.push({
                name: item.name,
                path: item.url,
                id: item.id,
              });
            }
          });
          this.menuData = arr;
          this.setActive();
        }
      });
    },
    refreshTime() {
      //开发环境更新过期时间
      let env = process.env.VUE_APP_ENV;
      if (localStorage.getItem("token") && ["development", "devProd"].indexOf(env) > -1) {
        let data = {
          accountId: JSON.parse(localStorage.getItem("loginInfo")).accountId,
          originalEnable: true,
          loginDeviceType: "1",
          token: localStorage.getItem("token"),
        };
        getRefreshTime(data).then((res) => { });
      }
    },
  },

  async created() {
    await this.getLoginInfo();
    await this.getWebList();
  },
  mounted() {
    const flag = isHiddenList.findIndex((item) => item.url === this.$route.path);
    flag > -1 ? (this.isHidden = false) : (this.isHidden = true);
  },
  watch: {
    $route: {
      handler(val, oldval) {
        this.setActive();
      },
      // 深度观察监听
      deep: true,
    },
  },
};
</script>
<style scoped>
.el-menu-box {
  height: 48px;
  background-color: rgb(255, 255, 255) !important;
  display: flex;
  align-items: center;
  flex: 1;
}

.boss-web-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  height: 100vh;
  width: 100%;
  z-index: 99999;
  background-color: #fff;
}

.el-menu-box .el-menu-item {
  padding: 0 20px;
  list-style: none;
  position: relative;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  box-sizing: border-box;
  white-space: nowrap;
}

ul {
  list-style-type: none;
  text-align: left;
}

li {
  display: inline-block;
  cursor: pointer;
  font-size: 15px;
  line-height: 48px;
  height: 48px;
  background: white !important;
}

.main-menu {
  width: 200px;
  text-align: center;
  float: left;
}

.main-menu img {
  width: 170px;
  height: 32px;
  vertical-align: middle;
}

.is-lang {
  width: 150px;
  height: 26px;
}

a {
  color: #42b983;
}

.log-out {
  font-size: 14px;
  padding-left: 0 !important;
}

.login-info {
  font-size: 14px;
  padding-left: 0 !important;
}

.login-info.is-active {
  border-bottom: none !important;
}

.el-menu-box {
  box-shadow: 0px 2px 20px rgb(31 36 41 / 6%);
}

.el-menu-main .el-menu-item.is-active {
  color: #1f2429 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid #0091ff;
}

.el-menu-box {
  position: fixed;
  top: 0;
  z-index: 1100;
  width: 100%;
}

.active-disable {
  border-bottom: none !important;
}

.nav {
  display: inline-flex;
  align-items: center;
  flex: auto;
}

.flex {
  display: flex;
  align-items: center;
}
</style>
<style scoped>
/deep/.el-menu-not .el-menu-item.is-active {
  border-bottom: none !important;
}
</style>
